import React from 'react';
import { Desktop, Mobile } from '../../../../app-responsive';
import { formatNumber, formatNumberToCurrency } from '../../../../app-actions';
import './estimated-total-box.css';

const EstimatedTotalBox = (props) => {
  const {
    title,
    totalCost,
    perLabel,
    dataInclusion,
    inclGSTText,
    gbText,
    totalMonthText,
    totalInclusionText,
    asterisk,
  } = props.estimatedSection;

  return (
    <div className="estimated-box">
      <Desktop>
        <div className="row">
          <div className="col-md-12 estimated-monthly-cost estimated-cost-description">
            {title}
            <sub>&nbsp;{inclGSTText}</sub>
          </div>
          <div className="col-md-12 row estimated-monthly-cost">
            <div className="col-6 p-d-0 row border-right">
              <div className="col-12 p-d-0 sub-title-head">
                {totalMonthText}
              </div>
              <div className="col-12 p-d-0 estimated-cost-price">
                <sup>$</sup>
                {formatNumber(totalCost)}
                {asterisk &&
                  <sup className="asterisk">{asterisk}</sup>
                }
                {perLabel &&
                  <sub className={asterisk && 'asterisk-sub'}>{perLabel}</sub>
                }
              </div>
            </div>
            <div className="col-6 p-d-0 row border-left">
              <div className="col-12 p-d-0 sub-title-head">
                {totalInclusionText}
              </div>
              <div className="col-12 p-d-0 estimated-cost-price">
                {formatNumberToCurrency(dataInclusion, '')}
                <sup className="gb-text">{gbText}</sup>
                {perLabel &&
                <sub className="per-label-text">{perLabel}</sub>
                }
              </div>
            </div>
          </div>
        </div>
      </Desktop>
      <Mobile>
        <div className="row estimated-monthly-cost">
          <div className="col-12  estimated-cost-description">
            {title}
            <sub>&nbsp;{inclGSTText}</sub>
          </div>
          <div className="col-12 row ">
            <div className="col-12 p-d-0 row border-right">
              <div className="col-12 p-d-0 sub-title-head">
                {totalMonthText}
              </div>
              <div className="col-12 p-d-0 estimated-cost-price">
                <sup>$</sup>
                {formatNumber(totalCost)}
                {asterisk &&
                  <sup className="asterisk">{asterisk}</sup>
                }
                {perLabel &&
                  <sub>{perLabel}</sub>
                }
              </div>
            </div>
            <div className="col-12 p-d-0 row border-left">
              <div className="col-12 p-d-0 sub-title-head">
                {totalInclusionText}
              </div>
              <div className="col-12 p-d-0 estimated-cost-price">
                {formatNumberToCurrency(dataInclusion, '')}
                <sup className="gb-text">{gbText}</sup>
                {perLabel &&
                <sub className="per-label-text">{perLabel}</sub>
                }
              </div>
            </div>
          </div>
        </div>
      </Mobile>
    </div>
  );
};

export default EstimatedTotalBox;
